import { Box, MenuItem, MenuList, Popover, StandardTextFieldProps, TextField } from '@material-ui/core'
import React, { ChangeEvent, useMemo, useState } from 'react'

type Data = {
    label: string,
    value: string,
    children?: Data[]
}

interface CascaderProps extends StandardTextFieldProps {
    datas?: Data[],
    value: { [key: string]: string[] },
    onChange: (event?: ChangeEvent, value?: { [key: string]: string[] }) => void
}

const Cascader = ({ datas, value, onChange, ...props }: CascaderProps) => {

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>()
    const [currentIndex, setCurrentIndex] = useState<number>()
    const handleShow = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event?.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const parentChecked = (id: string, index: number) => {
        return Boolean(value && value[id] && value[id].length > 0) || currentIndex === index
    }

    const childChecked = (id: string, parentId: string) => {

        return Boolean(value && value[parentId]?.includes(id))
    }

    const handleChildrenClick = (index: number) => () => {
        if (datas && currentIndex != undefined) {
            const newValue = value || {}
            const parent = datas[currentIndex]
            if (parent.children) {
                const children = parent.children[index]
                if (newValue[parent.value]) {
                    if (newValue[parent.value].includes(children.value)) {
                        newValue[parent.value] = newValue[parent.value].filter(v => v !== children.value)
                    } else {
                        newValue[parent.value] = [...newValue[parent.value], children.value]
                    }
                } else {
                    newValue[parent.value] = [children.value]
                }
            }
            onChange(undefined, newValue)
        }
    }

    const showValue = useMemo(() => {
        if (value && datas) {
            const values = []
            for (const parentId of Object.keys(value)) {
                const childrenValues = value[parentId]
                const [parent] = datas.filter(d => d.value === parentId)
                const names = parent.children?.filter(c => childrenValues.includes(c.value)).map(c => c.label)
                if (names) {
                    values.push(...names)
                }
                return values.join(',')
            }
        }
        return ''
    }, [value, datas])

    const handleSelectAll = () => {
        const newValue = value || {}
        if (datas && currentIndex !== undefined) {
            const parent = datas[currentIndex]
            if (parent && parent.children?.length === value[parent.value]?.length) {
                newValue[parent.value] = []

            } else if (parent.children) {
                newValue[parent.value] = parent.children.map(c => c.value)
            }
            onChange(undefined, newValue)
        }

    }

    return <>
        <TextField {...props} onClick={handleShow} value={showValue} onChange={() => { }} />
        <Popover open={open} anchorEl={anchorEl} anchorOrigin={{ vertical: 'top', horizontal: 'left' }} onClose={handleClose}>
            <Box display="flex">
                <Box maxHeight="400px" minWidth="200px" borderRight="1px solid #e1e1e1" overflow="hidden scroll">
                    <MenuList>
                        {datas?.map((d, index) => {
                            return <MenuItem selected={parentChecked(d.value, index)} onClick={() => setCurrentIndex(index)} key={d.value}>{d.label}</MenuItem>
                        })}
                    </MenuList>
                </Box>
                {currentIndex !== undefined && !!datas && datas[currentIndex].children && <Box maxHeight="400px" minWidth="200px" borderRight="1px solid #e1e1e1" overflow="hidden scroll">
                    <MenuList >
                        <MenuItem onClick={handleSelectAll}>全选</MenuItem>
                        {datas[currentIndex].children?.map((d, index) => {
                            return <MenuItem selected={childChecked(d.value, datas[currentIndex].value)} onClick={handleChildrenClick(index)} key={d.value}>{d.label}</MenuItem>
                        })}
                    </MenuList>
                </Box>}
            </Box>
        </Popover>
    </>
}

export default Cascader